<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="flowServiceForm" :model="formData" class="full-width-input" :disable="readOnly"
      :rules="rules" style="width: 100%;"
      label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="主题名称" prop="ServiceSubject.subjectName">
            <el-input class="input-item" v-if="!readOnly" v-model="formData.ServiceSubject.subjectName"
              :clearable="true" placeholder="主题名称"
            />
            <span class="input-item input-label" v-else>{{formData.ServiceSubject.subjectName}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="服务类型" prop="ServiceSubject.serviceType">
            <el-select class="input-item" v-if="!readOnly" v-model="formData.ServiceSubject.serviceType" :clearable="true" filterable
              placeholder="服务类型" :loading="flowServiceForm.serviceType.impl.loading"
              @visible-change="flowServiceForm.serviceType.impl.onVisibleChange"
              @change="onServiceTypeValueChange">
              <el-option v-for="item in flowServiceForm.serviceType.impl.dropdownList" :key="item.id"
                :value="item.id" :label="item.name"
              />
            </el-select>
            <span class="input-item input-label" v-else>{{(formData.ServiceSubject.serviceTypeDictMap || {}).name}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="行业领域" prop="ServiceSubject.industryId">
            <el-cascader class="input-item" v-if="!readOnly" v-model="flowServiceForm.industryId.value" :options="flowServiceForm.industryId.impl.dropdownList" filterable
              :clearable="true" :show-all-levels="false" placeholder="行业领域"
              :props="{value: 'id', label: 'name', checkStrictly: true}"
              @visible-change="flowServiceForm.industryId.impl.onVisibleChange"
              @change="onIndustryIdValueChange"
            />
            <span class="input-item input-label" v-else>{{(formData.ServiceSubject.industryIdDictMap || {}).name}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="关键词" prop="ServiceSubject.keyWords">
            <el-input class="input-item" v-if="!readOnly" v-model="formData.ServiceSubject.keyWords"
              :clearable="true" placeholder="关键词"
            />
            <span class="input-item input-label" v-else>{{formData.ServiceSubject.keyWords}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="服务简介" prop="ServiceSubject.serviceDesc">
            <el-input class="input-item" v-if="!readOnly" v-model="formData.ServiceSubject.serviceDesc"
              type="textarea"
              :autosize="{minRows: 2, maxRows: 4}"
              :clearable="true" placeholder="服务简介"
            />
            <span class="input-item input-label" v-else>{{formData.ServiceSubject.serviceDesc}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="地址" prop="ServiceSubject.serviceLocation">
            <el-input class="input-item" v-if="!readOnly" v-model="formData.ServiceSubject.serviceLocation"
                      :clearable="true" placeholder="地址"
            />
            <span class="input-item input-label" v-else>{{formData.ServiceSubject.serviceLocation}}</span>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="图片" prop="ServiceSubject.attachedFiles">

            <el-upload v-if="!readOnly"
                       class="upload-demo" name="uploadFile" :headers="getUploadHeaders"
                       :action="getUploadActionUrl('/admin/app/ServiceSubject/upload')"
                       :data="{fieldName: 'attachedFiles', asImage: true}"
                       :on-success="onAttachedFilesUploadSuccess"
                       :on-remove="onAttachedFilesRemoveFile"
                       :before-upload="pictureFile"
                       :on-error="onUploadError"
                       :show-file-list="true"
                       :on-preview="handlePreview"
                       :limit="flowServiceForm.attachedFiles.impl.maxCount"
                       :on-exceed="onUploadLimit"
                       :file-list="flowServiceForm.attachedFiles.impl.fileList"
                       list-type="picture">
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
            <template v-else>
              <el-image v-for="item in parseUploadData(formData.ServiceSubject.attachedFiles, {id: formData.ServiceSubject.id,
                  fieldName: 'attachedFiles', asImage: true})"
                        :preview-src-list="getPictureList(formData.ServiceSubject.attachedFiles, {id: formData.ServiceSubject.id, fieldName: 'attachedFiles', asImage: true})"
                        class="table-cell-image" :key="item.url" :src="item.url" fit="scale-down">
                <div slot="error" class="table-cell-image">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </template>
          </el-form-item>

        </el-col>
      </el-row>
    </el-form>
    <el-image-viewer v-if="imgViewerVisible" :on-close="closeImgViewer" :url-list="imgList" />

  </div>
</template>

<script>
import { mapActions } from 'vuex';
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
import flowMixins from '../../mixins/flowMixins.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { ServiceSubjectController, CommentController, DictionaryController } from '@/api';
import { FlowOperationController } from '@/api/flowController.js';

const processDefinitionKey = 'flowService';

export default {
  components: {
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')
  },
  name: 'flowServiceForm',
  props: {
    // 是否运行时任务
    isRuntimeTask: {
      type: [Boolean, String]
    },
    // 是否草稿
    isDraft: {
      type: [Boolean, String],
      default: false
    },
    // 是否只读
    readOnly: {
      type: Boolean,
      default: false
    },
    // 流程实例id
    processInstanceId: {
      type: String
    },
    // 抄送消息id
    messageId: {
      type: String
    },
    // 当前任务实例id
    taskId: {
      type: String
    },
    // 任务变量列表
    taskVariableList: {
      type: Array
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin, flowMixins],
  data () {
    return {
      imgViewerVisible: false,
      imgList: [],
      formData: {
        ServiceSubject: {
          id: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          orgCode: undefined,
          deletedFlag: undefined,
          subjectName: undefined,
          serviceType: undefined,
          specialistId: undefined,
          industryId: undefined,
          keyWords: undefined,
          serviceDesc: undefined,
          attachedFiles: undefined,
          commentList: [],
          isDatasourceInit: false
        }
      },
      // 保存草稿后返回的taskId
      draftTaskId: undefined,
      // 保存草稿后返回的流程实例ID
      draftProcessInstanceId: undefined,
      rules: {
        'ServiceSubject.serviceDesc': [
          {required: true, message: '请输入服务简介', trigger: 'blur'}
        ],
        'ServiceSubject.industryId': [
          {required: true, message: '请输入行业领域', trigger: 'blur'}
        ],
        'ServiceSubject.serviceType': [
          {required: true, message: '请输入服务类型', trigger: 'blur'}
        ],
        'ServiceSubject.subjectName': [
          {required: true, message: '请输入主题名称', trigger: 'blur'}
        ],
        'ServiceSubject.keyWords': [
          {required: true, message: '请输入关键词', trigger: 'blur'}
        ]
      },
      flowServiceForm: {
        formFilter: {
        },
        formFilterCopy: {
        },
        serviceType: {
          impl: new DropdownWidget(this.loadServiceTypeDropdownList)
        },
        industryId: {
          impl: new DropdownWidget(this.loadIndustryIdDropdownList, true, 'id', 'parentId'),
          value: []
        },
        attachedFiles: {
          impl: new UploadWidget(3)
        },
        isInit: false
      }
    }
  },
  methods: {
    // 启动流程
    handlerStart (operation, copyItemList, xml) {
      // 启动并保存草稿后再次提交
      if (this.draftProcessInstanceId != null && this.draftTaskId != null) {
        return this.handlerOperation(operation, copyItemList);
      }
      return new Promise((resolve, reject) => {
        this.$refs.flowServiceForm.validate(valid => {
          if (!valid) return reject();
          this.preHandlerOperation(operation, true, xml).then(res => {
            let formData = this.getMasterData(operation.type, (res || {}).assignee);
            return ServiceSubjectController.startAndTakeUserTaskFlowService(this, {
              processDefinitionKey: processDefinitionKey,
              taskVariableData: {
                ...formData.taskVariableData,
                latestApprovalStatus: operation.latestApprovalStatus
              },
              flowTaskCommentDto: {
                approvalType: operation.type
              },
              serviceSubjectDto: {
                ...formData.masterData
              },
              ...formData.relationData,
              copyData: (copyItemList || []).reduce((retObj, item) => {
                retObj[item.type] = item.id;
                return retObj;
              }, {})
            });
          }).then(res => {
            this.$message.success('启动成功！');
            resolve();
          }).catch(e => {
            reject(e);
          });
        });
      });
    },
    // 流程操作
    handlerOperation (operation, copyItemList, xml) {
      return new Promise((resolve, reject) => {
        this.$refs.flowServiceForm.validate(valid => {
          if (!valid) return reject();
          this.preHandlerOperation(operation, this.isDraft, xml).then(res => {
            // 加签、减签操作
            if (operation.type === this.SysFlowTaskOperationType.CO_SIGN || operation.type === this.SysFlowTaskOperationType.SIGN_REDUCTION) {
              return this.submitConsign((res || {}).assignee, operation.type === this.SysFlowTaskOperationType.CO_SIGN);
            }
            // 自由跳
            if (operation.type === this.SysFlowTaskOperationType.FREE_JUMP) {
              return FlowOperationController.freeJump(this, {
                processInstanceId: this.processInstanceId,
                sourceTaskId: this.taskId,
                targetTaskKey: (res || {}).targetTaskKey,
                delegateAssignee: (res || {}).assignee,
                taskComment: (res || {}).message,
                taskVariableData: {
                  latestApprovalStatus: operation.latestApprovalStatus
                }
              });
            }
            // 驳回操作
            if (operation.type === this.SysFlowTaskOperationType.REJECT || operation.type === this.SysFlowTaskOperationType.REJECT_TO_TASK) {
              return FlowOperationController.rejectRuntimeTask(this, {
                processInstanceId: this.processInstanceId,
                taskId: this.taskId,
                targetTaskKey: (res || {}).targetTaskKey,
                taskComment: (res || {}).message,
                taskVariableData: {
                  latestApprovalStatus: operation.latestApprovalStatus
                }
              });
            }
            // 驳回到起点
            if (operation.type === this.SysFlowTaskOperationType.REJECT_TO_START) {
              return FlowOperationController.rejectToStartUserTask(this, {
                processInstanceId: this.processInstanceId,
                taskId: this.taskId,
                taskComment: (res || {}).message,
                taskVariableData: {
                  latestApprovalStatus: operation.latestApprovalStatus
                }
              });
            }
            // 撤销操作
            if (operation.type === this.SysFlowTaskOperationType.REVOKE) {
              this.$confirm('是否撤销此任务？').then(res => {
                return FlowOperationController.rejectHistoricTask(this, {
                  processInstanceId: this.processInstanceId,
                  taskId: this.taskId,
                  taskComment: '任务处理人撤销任务',
                  taskVariableData: {
                    latestApprovalStatus: operation.latestApprovalStatus
                  }
                });
              }).catch(e => {
                return Promise.reject(e);
              });
            }
            let formData = this.getMasterData(operation.type, (res || {}).assignee);
            let params = {
              taskId: this.taskId || this.draftTaskId,
              processInstanceId: this.processInstanceId || this.draftProcessInstanceId,
              flowTaskCommentDto: {
                taskComment: (res || {}).message,
                approvalType: operation.type,
                delegateAssignee: operation.type === this.SysFlowTaskOperationType.TRANSFER ? (res || {}).assignee : undefined
              },
              taskVariableData: {
                ...formData.taskVariableData,
                latestApprovalStatus: operation.latestApprovalStatus
              },
              copyData: (copyItemList || []).reduce((retObj, item) => {
                retObj[item.type] = item.id;
                return retObj;
              }, {})
            }
            // 非只读状态下，提交修改数据
            if (!this.readOnly) {
              // 主表数据
              params.serviceSubjectDto = {
                ...formData.masterData
              };
              // 关联数据
              params = {
                ...params,
                ...formData.relationData
              };
            }

            return ServiceSubjectController.submitUserTaskFlowService(this, params);
          }).then(res => {
            this.reloadMessage(this);
            if (operation.type !== this.SysFlowTaskOperationType.CO_SIGN && operation.type !== this.SysFlowTaskOperationType.SIGN_REDUCTION) {
              this.$message.success(operation.label + '成功！');
            }
            resolve();
          }).catch(e => {
            console.log(e);
          });
        });
      });
    },
    // 保存草稿
    handlerDraft () {
      return new Promise((resolve, reject) => {
        let formData = this.getFormDataImpl();
        let params = {
          processDefinitionKey: processDefinitionKey,
          processInstanceId: this.processInstanceId || this.draftProcessInstanceId,
          serviceSubjectDto: {
            ...formData.masterData
          },
          ...formData.relationData
        }
        ServiceSubjectController.startAndSaveDraftFlowService(this, params).then(res => {
          this.$message.success('草稿保存成功！');
          this.draftProcessInstanceId = res.data.processInstanceId;
          this.draftTaskId = res.data.taskId;
          resolve();
        }).catch(e => {
          reject(e);
        });
      });
    },
    // 获取表单数据
    getFormDataImpl () {
      // 一对一、一对多、多对多关联数据
      let relationData = {};

      return {
        masterData: {
          ...this.formData.ServiceSubject
        },
        relationData: relationData
      }
    },
    // 获取流程表单数据
    getMasterData (operationType, assignee) {
      let taskVariableData;
      if (Array.isArray(this.taskVariableList) && this.taskVariableList.length > 0) {
        taskVariableData = this.taskVariableList.reduce((retObj, item) => {
          retObj[item.variableName] = this.formData.ServiceSubject[item.variableName] || '';
          return retObj;
        }, {});
      }
      // 会签操作设置多实例处理人集合
      assignee = (assignee && assignee !== '') ? assignee.split(',') : undefined;
      if (operationType === this.SysFlowTaskOperationType.MULTI_SIGN) {
        if (taskVariableData == null) taskVariableData = {};
        taskVariableData.assigneeList = assignee;
      } else if (operationType === this.SysFlowTaskOperationType.SET_ASSIGNEE) {
        if (taskVariableData == null) taskVariableData = {};
        taskVariableData.appointedAssignee = Array.isArray(assignee) ? assignee.join(',') : undefined;
      }

      return {
        ...this.getFormDataImpl(),
        taskVariableData
      }
    },
    // 初始化流程表单
    initFormData () {
      if (!this.isStartFlow) {
        // 流程办理
        let params = {
          processInstanceId: this.processInstanceId,
          taskId: this.taskId
        }
        let httpCall = null;
        if (this.isDraft || this.isDraft === 'true') {
          // 草稿数据
          httpCall = FlowOperationController.viewDraftData(this, {
            processDefinitionKey: processDefinitionKey,
            processInstanceId: this.processInstanceId
          });
        } else if (this.messageId != null) {
          // 抄送消息
          httpCall = FlowOperationController.viewCopyBusinessData(this, {
            messageId: this.messageId
          });
        } else {
          httpCall = (this.taskId && this.isRuntime) ? ServiceSubjectController.viewTaskBusinessDataFlowService(this, params) : ServiceSubjectController.viewHistoricTaskBusinessDataFlowService(this, params)
        }
        httpCall.then(res => {
          this.formData.ServiceSubject = { ...res.data };
          this.flowServiceForm.serviceType.impl.onVisibleChange(true).catch(e => {});
          let attachedFilesDownloadParams = {
            id: this.formData.ServiceSubject.id,
            fieldName: 'attachedFiles',
            asImage: true
          }
          this.flowServiceForm.attachedFiles.impl.fileList = this.parseUploadData(this.formData.ServiceSubject.attachedFiles, attachedFilesDownloadParams);
          // 获取一对多、多对多数据
          this.refreshFlowServiceForm(true);
        }).catch(e => {});
      } else {
        // 启动流程
      }
    },
    onCancel (isSuccess) {
      if (this.observer != null) {
        this.observer.cancel(isSuccess);
      }
    },
    /**
     * 服务类型下拉数据获取函数
     */
    loadServiceTypeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictRSTypeDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 服务类型选中值改变
     */
    onServiceTypeValueChange (value) {
    },
    /**
     * 行业领域下拉数据获取函数
     */
    loadIndustryIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictIndustryDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 行业领域选中值改变
     */
    onIndustryIdValueChange (value) {
      this.formData.ServiceSubject.industryId = Array.isArray(value) ? value[value.length - 1] : undefined;
    },
    /**
     * 更新专家服务表单
     */
    refreshFlowServiceForm (reloadData = false) {
      if (!this.flowServiceForm.isInit) {
        // 初始化下拉数据
      }
      this.flowServiceForm.isInit = true;
    },
    onAttachedFilesUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.uploadPath = response.data.uploadPath;
        file.url = URL.createObjectURL(file.raw);
        this.flowServiceForm.attachedFiles.impl.onFileChange(file, fileList);
        this.formData.ServiceSubject.attachedFiles = this.fileListToJson(this.flowServiceForm.attachedFiles.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
     * 移除附件
     */
    onAttachedFilesRemoveFile (file, fileList) {
      this.flowServiceForm.attachedFiles.impl.onFileChange(file, fileList);
      this.formData.ServiceSubject.attachedFiles = this.fileListToJson(this.flowServiceForm.attachedFiles.impl.fileList);
    },
    onUploadError (e, file, fileList) {
      this.$message.error('文件上传失败');
    },
    onUploadLimit (files, fileList) {
      this.$message.error('已经超出最大上传个数限制');
    },
    formInit () {
      this.initFormData();
    },
    closeImgViewer () {
      this.imgViewerVisible = false;
    },
    handlePreview (file) {
      this.imgViewerVisible = true
      this.imgList = []
      this.imgList.push(file.url)
    },
    ...mapActions(['reloadMessage'])
  },
  computed: {
    isStartFlow () {
      return this.processInstanceId == null;
    },
    isRuntime () {
      return typeof this.isRuntimeTask === 'string' ? this.isRuntimeTask === 'true' : this.isRuntimeTask;
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  }
}
</script>
